import { axios } from "../services/axios";
import {
  DOWNLOAD_DEFICIENCY,
  INSEPCTED_MACHINES,
  INSEPCTED_MACHINES_CERTIFICATE,
  INSEPCTED_MACHINES_DOCUMENT,
  SHARE_CERTIFICATE
} from "../constants/paths";
import { InspectionsDTO } from "./interface/inspection";

/**
 * inspection machine / device API call
 * @param  userId
 * @returns {Promise<any>}
 */
export const inspectionsApiCall = (
  data: InspectionsDTO,
  userId: number
): Promise<any> => {
  return axios.get(`${INSEPCTED_MACHINES}/${userId}`, {
    params: data,
  });
};

/**
 * inspected machine document API call
 * @param  id
 */
export const downloadDocumentsApiCall = (id: number) => {
  return axios.get(`${INSEPCTED_MACHINES_DOCUMENT}/${id}`);
};

/**
 * inspected machine certificate API call
 * @param  id
 */
export const downloadCertificateApiCall = (id: number) => {
  return axios.get(`${INSEPCTED_MACHINES_CERTIFICATE}/${id}`);
};

/**
 * download machine deficiency report API call
 * @param  id
 */
export const downloadDeficiencyApiCall = (id: number) => {
  return axios.get(`${DOWNLOAD_DEFICIENCY}/${id}`);
};


export const shareCertifictaeAPICall = async(data) =>{

  return await axios.post(SHARE_CERTIFICATE , data, {
  });
}